import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "12px",
	height: "11px",
	viewBox: "0 0 12 11",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Star" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Design",
			stroke: "none",
			strokeWidth: 1,
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Overview",
				transform: "translate(-412.000000, -952.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-Copy-8",
					transform: "translate(388.000000, 931.000000)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M30,30 L27.3700246,31.3826599 C27.1256023,31.5111603 26.8232887,31.4171871 26.6947883,31.1727648 C26.6436188,31.0754345 26.6259614,30.9639505 26.6445498,30.8555717 L27.1468305,27.927051 L27.1468305,27.927051 L25.0191356,25.8530611 C24.8213938,25.6603105 24.8173477,25.3437539 25.0100983,25.1460121 C25.0868526,25.0672703 25.1874238,25.0160267 25.2962423,25.0002144 L28.2366442,24.572949 L28.2366442,24.572949 L29.551632,21.9084929 C29.6738431,21.660866 29.973656,21.5591965 30.2212829,21.6814077 C30.3198892,21.7300728 30.3997029,21.8098866 30.448368,21.9084929 L31.7633558,24.572949 L31.7633558,24.572949 L34.7037577,25.0002144 C34.9770301,25.0399232 35.1663708,25.2936447 35.126662,25.5669171 C35.1108498,25.6757356 35.0596062,25.7763068 34.9808644,25.8530611 L32.8531695,27.927051 L32.8531695,27.927051 L33.3554502,30.8555717 C33.4021307,31.1277399 33.2193368,31.3862179 32.9471685,31.4328984 C32.8387897,31.4514868 32.7273057,31.4338294 32.6299754,31.3826599 L30,30 L30,30 Z",
						id: "Star"
					})
				})
			})
		})
	]
});
export default SvgStar;
